export default __webpack_public_path__ + "static/media/daily.6a251151.png";